import config from '@/config/constants.js';
// import {firebase} from "@/config/firebase";
import axios from "axios";

export default {
    namespaced: true,
    state: {
        status: '',
    },
    mutations: {
        loading(state) {
            state.status = 'loading';
        },
        status(state, status) {
            state.status = status;
        },
    },
    actions: {
        send_mail: function ({commit}, info) {
            commit('loading');
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve) {
                try {
                    await axios.post(config.api_url + 'web/support', info).then(response => {
                        if (response.status === 200) {
                            resolve(response);
                            commit('status', 'success');
                        } else {
                            commit('status', 'error');
                        }
                    });
                } catch (error) {
                    console.error(error);
                }
                resolve(false);
            });
        },
    }
}